import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';


@Component({
  selector: 'view-popup',
  templateUrl: './view-popup.component.html',
  styleUrls: ['./view-popup.component.css']
})
export class ViewPopupComponent {

  public text: string;

  constructor(
    protected dialogRef: NbDialogRef<ViewPopupComponent>,
    private toastrService: NbToastrService,
  ) 
  { 
    this.text = "";
  }

  cancel() {
    this.dialogRef.close();
  } 

  clickCopyText(){
    navigator.clipboard.writeText(this.text).then(() => {
      this.toastrService.show('', 'Text copied to clipboard', { status: 'info', icon: 'info' });
      this.cancel();
    },() => {
      this.toastrService.show('', 'Error when trying to copy text to clipboard', { status: 'danger' });
      this.cancel();
    })
  }
}
